export const getFontScale = () => {
  const fontSizeRoot = +globalThis
    .getComputedStyle(document.documentElement)
    .fontSize.replace('px', '');

  return fontSizeRoot / 16;
};

export const pxToRem = (pixels: number, fontSizeRoot: number = 16) => `${pixels / fontSizeRoot}rem`;
